export const teamData = [
  {
    role: "Director",
    name: "Arq. Jose Manuel Aripez Dominguez",
    image: "/images/pfp.webp",
    description:
      "Responsible for cost control and detailed budget analysis",
  },
  {
    role: "Construction Manager",
    name: "Ing. -",
    image: "/images/pfp.webp",
    description:
      "Manages design concepts and the project's aesthetic integration.",
  },
  {
    role: "Design Coordinator",
    name: "Arq. -",
    image: "/images/pfp.webp",
    description:
      "Oversees construction processes and technical coordination.",
  },
  {
    role: "Budgeting Specialist",
    name: "Ing. -",
    image: "/images/pfp.webp",
    description:
      "Leads the studio, ensuring quality standards and strategic vision.",
  },
];
